const EN = 'en-us'
const ZH = 'zh-cn'

export function isEn() {
  return sessionStorage.getItem('locale') === EN
}

export function isZH() {
  return sessionStorage.getItem('locale') === ZH
}

export function i18n(data) {
  // 当前语⾔是默认语⾔时，不需要处理
  const locale = sessionStorage.getItem('locale') || ZH
  if(locale === ZH){
    return data;
  }
  // 获取后缀
  const simpleLocale = locale.substring(0, 1).toUpperCase() + locale.substring(1, locale.indexOf('-'))
  // 遍历结构，如果存在语⾔后缀属性，则覆盖原属性
  for (let field in data) {
    if (Array.isArray(data[field])) {
      for (let sonField of data[field]) {
        i18n(sonField)
      }
    } else if (data[field] instanceof Object) {
      i18n(data[field]);
    } else {
      let valueByLang = data[field + 'I18n' + simpleLocale];
      if(valueByLang){
        data[field] = valueByLang;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/i18n/il8nUtil.js